module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-progress"
    }
  }, [_c('div', {
    staticClass: "levels"
  }, [_vm._v("LEVEL: "), _c('span', [_vm._v(_vm._s(_vm.level))])]), _vm._v(" "), _c('div', {
    staticClass: "scores"
  }, [_vm._v("SCORE: "), _c('span', [_vm._v(_vm._s(_vm.score))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ca94900","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScoresLevels.vue
// module id = 27
// module chunks = 0